/**
 * WebSocketのドメイン
 */
export const DOMAIN = process.env.REACT_APP_QN_WEBSOCKET_DOMAIN

// WebSocketの定義
export const WEBSOCKET: WebSocketsProps = {
  MAIN: {
    url: '',
  },
}

/**
 * 型定義：WebSocket定義
 */
export type WebSocketsProps = {
  [NAME: string]: WebSocketProps
}

/**
 * 型定義：個別のWebSocket定義
 */
export type WebSocketProps = {
  url: string
}

/**
 * 型定義：WebSocketで受信するメッセージ
 */
export type MessageProps = {
  type:
    | 'location'
    | 'status'
    | 'partnerName'
    | 'duration'
    | 'connectionId'
    | 'deleteConnection'
  content: any
}

/**
 * 型定義：パートナー位置情報の連携WebSocketのContent
 */
export type LocationContentProps = {
  receptionNo: string
  sendDate: string
  latitude: number
  longitude: number
  accuracy: number
  altitude: number
  speed: number
  bearing: number
  locateDate: string
  validity: boolean
  locationCooperation: number
}

/**
 * 型定義：QNステータスの連携WebSocketのContent
 */
export type StatusContentProps = {
  qnStatus: string
}

/**
 * 型定義：パートナー名の連携WebSocketのContent
 */
export type PartnerNameContentProps = {
  partnerName: string
}

/**
 * 型定義：パートナー到着時間（分）の連携WebSocketのContent
 */
export type DurationContentProps = {
  duration: number
  siteArrivalScheduleDate: string
  timeComingSoon: number
}

/**
 * 型定義：WebSocketのConnectionIdの連携WebSocketのContent
 */
export type ConnectionIdContentProps = {
  connectionId: string
}

/**
 * 型定義：WebSocket切断の連携WebSocketのContent
 */
export type DeleteConnectionContentProps = {}
